<template>
  <vx-card
    id="loading-headcount-indicator"
    class="vs-con-loading__container w-full pointer"
    @click="handleClick"
  >
    <vs-row vs-type="flex">
      <vs-col vs-type="flex" vs-justify="center" 
        vs-lg="1"
        vs-sm="1"
        vs-xs="1">
        <feather-icon icon="UsersIcon" class="colorBoxH mr-2 mt-1" />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="start"
        vs-lg="6"
        vs-sm="6"
        vs-xs="6"
        class="ml-4 mt-4"
      >
        {{ $t('headcount') | capitalize }}
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="end"
        vs-lg="4"
        vs-sm="4"
        vs-xs="4"
        class="mt-3"
      >
        <span class="card-value">{{ this.headCountTotal }} </span>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import dashboardTV from '@/http/requests/dashboard'
import loading from '@/mixins/Loading.js'

export default {
  props: {
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [loading],
  data() {
    return {
      name: 'headcount-indicator',
      loading: false,
      headCountTotal: 0,
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
    getData() {
      this.loading = true
      dashboardTV
        .headcountCard()
        .then((res) => {
          this.headCountTotal = res.data.headcount
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
  },
  mounted() {
    this.getData()
    if (this.refresh === true) {
      var v = this
      setInterval(function () {
        v.getData()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#loading-${this.name}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#loading-${this.name} > .con-vs-loading`)
      }
    },
  },
}
</script>

<style>
.colorBoxH {
  padding: 5px;
  border-radius: 6px;
  color: rgb(112, 101, 236);
  background: rgba(112, 101, 236, 0.25);
}
.card-value {
  font-weight: bold;
}
</style>